import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import LeadNovoPage from '@/pages/leads/lead-novo'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

const searchSchema = z.object({
  contatoId: z.number().optional(),
})

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/leads/novo',
)({
  validateSearch: searchSchema,
  component: function LeadNovoRoute() {
    const { dashboardId } = Route.useParams()
    const { contatoId } = Route.useSearch()
    return (
      <ProtectedRoute
        anyOf={[CAPABILITIES.LEADS_ALL, CAPABILITIES.LEADS_OWN]}
        dashboardId={dashboardId}
      >
        <LeadNovoPage dashboardId={dashboardId} contatoId={contatoId} />
      </ProtectedRoute>
    )
  },
})

